import React, { useState, useEffect, useCallback } from 'react';
import { ColumnsType } from 'antd/es/table';
import { Input, DatePicker, Button, Badge, Select, Modal } from 'antd';
import { BaseTable } from '@app/components/common/BaseTable/BaseTable';
import { notificationController } from 'controllers/notificationController';
import moment from 'moment';
import { assignRiderAction, getAllOrdersAction, getAllRidersAction, getAllSubscriptionAction, updateRiderStatusAction } from '@app/store/slices/userSlice';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import styled from 'styled-components';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useNavigate } from 'react-router-dom';

const { RangePicker } = DatePicker;
const { Option } = Select;

export const AssignRiderTable: React.FC = (props) => {
    const [tableKey, setTableKey] = useState(0);
    const [filters, setFilters] = useState({
        clientName: '',
        deliveryDateRange: [],
        deliveryStatus: '',
    });
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const [tableData, setTableData] = useState({ data: [], loading: false, total: 0 });
    const dispatch = useAppDispatch();
    let navigate = useNavigate();

    const fetchData = useCallback(() => {
        setTableData((prev) => ({ ...prev, loading: true }));

        const params = {
            ...filters,
            deliveryDateRange: filters.deliveryDateRange.length
                ? [
                    moment(filters.deliveryDateRange[0]).toISOString(),
                    moment(filters.deliveryDateRange[1]).toISOString(),
                ]
                : [],
            current: pagination.current,
            pageSize: pagination.pageSize,
        };

        dispatch(getAllRidersAction(params))
            .unwrap()
            .then((response) => {
                setTableData({
                    data: response.data,
                    loading: false,
                    total: response.total,
                });
            })
            .catch((error) => {
                notificationController.error({ message: error.message || 'Failed to fetch data' });
                setTableData((prev) => ({ ...prev, loading: false }));
            });
    }, [filters, pagination, dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    console.log('fafafafafaf', props.isBulkAssign, props.selectedRowKeys)
    const handleFilterChange = (filterName: string, value: any) => {
        setFilters((prev) => ({ ...prev, [filterName]: value }));
    };

    const handleTableChange = (paginationInfo) => {
        setPagination({ current: paginationInfo.current, pageSize: paginationInfo.pageSize });
    };

    const handleAssignRiderChange = (record) => {
        Modal.confirm({
            title: 'Are you sure?',
            content: `Are you sure to perform this action?`,
            onOk: () => {
                // Call API to update the status
                dispatch(
                    assignRiderAction({
                        id: record._id, deliveryIds: (props.isBulkAssign && props.selectedRowKeys.length) > 0 ? props.selectedRowKeys : [props?.selectedDelivery?.orderId]
                    }) // Replace with the actual action for updating status
                )
                    .unwrap()
                    .then((resp) => {

                        if (resp.success) {
                            notificationController.success({
                                message: `Assigned Successfully`,
                            });
                            setTimeout(() => {

                                props.handleCancelBulkAssign();
                                props.fetchDeliveriesData();
                            }, 900);

                        }
                        else {
                            notificationController.success({
                                message: `${resp?.message || "Something went wrong"}`,
                            });
                        }
                    })
                    .catch((error) => {
                        notificationController.error({
                            message: error.message || 'Failed to update status',
                        });
                    });
            },
        });
    };

    const columns: ColumnsType<any> = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            render: (text, record) => <span>{record?.firstName || 'Not available'}</span>,
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            render: (text, record) => <span>{record?.lastName || 'Not available'}</span>,
        },
        {
            title: 'Mobile Number',
            dataIndex: 'phone',
            render: (text, record) => <span>{record?.phone || 'Not available'}</span>,
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            width: '15%',
            fixed: 'right',
            render: (text: string, record: any) => (
                <div style={{ display: 'block', justifyContent: 'space-between' }}>
                    {record.status == "Active" && record.isVerified ? <Button onClick={() => handleAssignRiderChange(record)}>Assign</Button>
                        : record.status == "Active" ? "Rider not active" : "Rider not verified"}
                </div>

            ),
        },
    ];

    return (
        <>

            <BaseTable
                key={tableKey}
                columns={columns}
                dataSource={tableData.data}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: tableData.total,
                }}
                loading={tableData.loading}
                onChange={handleTableChange}
                scroll={{ x: 800 }}
                bordered
            />
        </>
    );
};
